import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { useI18n } from "../../i18n";

export const Faq = () => {
  const { t } = useI18n();
  return (
    <section id="faq" className="py-24 lg:py-36 border-t border-white/10" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-4"
        >
          <p className="font-heading text-gold text-sm tracking-[0.25em] uppercase mb-6">{t("faq.kicker")}</p>
          <h2 className="font-heading font-bold tracking-tighter text-3xl sm:text-4xl lg:text-5xl">
            {t("faq.heading")} <span className="text-gold">{t("faq.headingGold")}</span>
          </h2>
          <p className="text-[#8A9DB1] leading-relaxed text-base md:text-lg mt-6 max-w-sm">{t("faq.sub")}</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-8"
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {t("faq.items").map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-heading text-left text-lg lg:text-xl font-medium tracking-tight py-7 hover:no-underline hover:text-[#E8A33D] [&[data-state=open]]:text-[#E8A33D] transition-colors duration-300">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#8A9DB1] text-base leading-relaxed pb-7 max-w-3xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default Faq;
